export default __webpack_public_path__ + "static/media/active_campaign_icon.437c574b.svg";